import { QueryClientProvider } from "@tanstack/react-query";
import 'bootstrap/dist/css/bootstrap.min.css';
import $ from 'jquery';
import { SnackbarProvider } from "notistack";
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { Helmet } from "react-helmet";
import { ParallaxProvider } from "react-scroll-parallax";
import App from './App';
import { queryClient } from './Common/config';
import { GENERAL } from "./Common/constant";
import { RecaptchaProvider } from './Common/Hook/useRecaptcha';
import MousePointer from './Pages/MousePointer';
import reportWebVitals from './reportWebVitals';

import 'swiper/css';
import "swiper/css/pagination";
import './assets/scss/Style.scss';

const RootComponent = () => {
  useEffect(() => {
    const handlePreloader = () => {
      if ($('.loader-wrap').length) {
        $('.loader-wrap').delay(1000).fadeOut(500);
      }
    };

    const createPreloaderRing = () => {
      $(".preloader-ring").each(function () {
        let text = $(this).text(),
          textArr = text.split(''),
          a = 0;
        $(this).html('');
        for (let i = 0; i <= 30; i++) {
          if (!textArr[i] || textArr[i] === " ") {
            textArr[i] = "";
          }
          $(this).append(
            '<div class="preloader-sector" style="transform: rotateY(' + a + 'deg) translateZ(160px)">' + textArr[i] + '</div>'
          );
          a = a + 12;
        }
      });
    };

    handlePreloader();
    createPreloaderRing();
  }, []);

  return (
    <div className="boxed_wrapper">
      {/* ---------------------------------- Open Graph ----------------------------------- */}
      <Helmet>
        <meta property="og:title" content="K-EGP" />
        <meta property="og:description" content="Enabling technology into people and process" />
        <meta property="og:image" content="https://cms.k-egp.com/uploads/logo_ac49c3a2bb.png" />
        <meta property="og:image:width" content="400" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={GENERAL.WEBSITE} />
      </Helmet>
      {/* -------------------------------------- End -------------------------------------- */}

      <MousePointer />
      <div className="loader-wrap">
        <div className="hendel__preloder">
          <div className="preloader">
            <div className="preloader-ring">K-EGP K-EGP K-EGP</div>
            <div className="preloader-ring">K-EGP K-EGP K-EGP</div>
          </div>
        </div>
      </div>
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          <ParallaxProvider>
            <SnackbarProvider preventDuplicate autoHideDuration={3000} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
              <RecaptchaProvider>
                <App />
              </RecaptchaProvider>
            </SnackbarProvider>
          </ParallaxProvider>
        </QueryClientProvider>
      </React.StrictMode>
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RootComponent />);
reportWebVitals();
